/** The account roles that manage billing: a parent, or an adult with no kids yet
 *  (the same rule the server's require_parent enforces). Kept free of imports so
 *  any billing surface can read it without pulling in StoreKit. */
export function isGrownUpRole(role: string | undefined): boolean {
  return role === "parent" || role === "adult";
}
